import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types"
import {Card} from "antd"
import * as ImportnActions from "../../reducers/import";
import {DetailsTitle} from "../../util/Util";
import ImportDetailTable from "./ImportDetailTable"
import ImportDetailTablePersons from "./ImportTableDetailPersons"

class importStatisticsDetails extends React.Component {

    static propTypes = {
        findSelection: PropTypes.func.isRequired,
        importStatisticsDetails: PropTypes.object.isRequired,
        fetchingSingle: PropTypes.bool.isRequired
    };
    state = {
        selectedRows: [], // Check here to configure the default column
    };
    onSelectChange = (selectedRows) => {
        console.log('selectedRowKeys changed: ', selectedRows);
        this.setState({selectedRows});
    };

    componentDidMount() {
        const {match, findSelection} = this.props;
        const urlId = match.params.id;
        findSelection(urlId);
    }
    render() {
        const {fetchingSingle, importStatisticsDetails, match} = this.props;
        return <div><Card
            title={<DetailsTitle icon="database">{match.params.id}</DetailsTitle>}
            loading={fetchingSingle}/>

            <div className="import-detail-container">
                <Card title="Imports pr country">
                <ImportDetailTable dataSource={importStatisticsDetails.importStatistics}
                               onSelectChange={this.onSelectChange}
                               loading={fetchingSingle}/>
                </Card>
                <Card title="Imports pr user">
                <ImportDetailTablePersons dataSource={importStatisticsDetails.importStatisticPersons}
                                   onSelectChange={this.onSelectChange}
                                   loading={fetchingSingle}/>
                </Card>
            </div>


        </div>

    }
}


const mapStateToProps = state => { console.log("map", state); return ({
    importStatisticsDetails: state.importStatistics.importStatisticsDetails,
    fetchingSingle: state.importStatistics.fetchingSingle
})};

const mapDispatchToProps = dispatch => ({
    findSelection: bindActionCreators(ImportnActions, dispatch).getImportStatisticsDetails
});

export default connect(mapStateToProps, mapDispatchToProps)(importStatisticsDetails)



// WEBPACK FOOTER //
// ./src/js/browse/import/importStatisticsDetails.js